import React, { useEffect, useState } from "react";

/**
 * Confetti - fires colorful pieces on mount. Used on the final slide.
 */
export const Confetti = ({ count = 120 }) => {
  const [pieces, setPieces] = useState([]);
  useEffect(() => {
    const colors = ["#FB923C", "#FACC15", "#34D399", "#60A5FA", "#F472B6", "#A78BFA", "#FFFFFF"];
    const arr = Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 2,
      duration: 3 + Math.random() * 3,
      color: colors[Math.floor(Math.random() * colors.length)],
      rotate: Math.random() * 360,
      size: 8 + Math.random() * 8,
    }));
    setPieces(arr);
  }, [count]);

  return (
    <div aria-hidden="true" style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden", zIndex: 3 }}>
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            background: p.color,
            width: p.size,
            height: p.size * 1.4,
            transform: `rotate(${p.rotate}deg)`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        />
      ))}
    </div>
  );
};
